import { render, staticRenderFns } from "./projectLeading.vue?vue&type=template&id=366989bd&scoped=true&"
import script from "./projectLeading.vue?vue&type=script&lang=js&"
export * from "./projectLeading.vue?vue&type=script&lang=js&"
import style0 from "./projectLeading.vue?vue&type=style&index=0&id=366989bd&lang=less&scoped=true&"
import style1 from "./projectLeading.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366989bd",
  null
  
)

export default component.exports